import { generatedTypesNew } from '@css-xp/graphtypes';

export const QUOTE_TABLE_DEFAULT_SORT_OPTIONS = {
  sortFields: ['createdDate', 'id'],
  sortFieldsDirections: [generatedTypesNew.SortDirection.DESC, generatedTypesNew.SortDirection.DESC],
};

export const NOTIFICATION_DISMISS_TIME = 5000;
export const QUOTE_POLLING_INTERVAL = 5000;
export const QUOTE_POLLING_MAX_TIMER = 120000;
